import { ApplicationUser } from '@/types/application-user';
import { OrganisationIdAndName } from '@/types/organisation';
import { organisationIdAndNameOnly } from './organisation-id-and-name-only';

export const updateUserWithOrganisation = (
  user: ApplicationUser,
  organisation: OrganisationIdAndName | undefined,
): ApplicationUser => ({
  ...user,
  organisation: organisation
    ? organisationIdAndNameOnly(organisation)
    : undefined,
});
